import React from 'react';
import { cn } from '../../lib/utils';

export const Container = React.forwardRef(
  ({ className, children, size = 'default', ...props }, ref) => {
    const sizeClasses = {
      sm: 'max-w-4xl',
      default: 'max-w-7xl',
      lg: 'max-w-[1440px]',
      full: 'max-w-full',
    };

    return (
      <div
        ref={ref}
        className={cn(
          'mx-auto px-4 sm:px-6 lg:px-8',
          sizeClasses[size],
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

export default Container;
